import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { GETImplementReport, UndercarriageImplementReport } from '../interpretation/models/interpretation.model';

@Injectable()
export class InterpretationreportService {
  public RequestResult: boolean = true;
  private ErrorResponse: any;
  constructor(private _http: Http) { }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
}


  
  public generateGETInspectionReport(info: GETImplementReport[]): Observable<number>{
    return this._http.post("api/RentalInterp/generateGETInspectionReport", info).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError); 
  }
  

  public generateUndercarriageInspectionReport(info: UndercarriageImplementReport[]): Observable<number> {
    return this._http.post("api/RentalInterp/generateUndercarriageInspectionReport", info).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  

}
